import { courierDetail as _COURIERS_ } from "@/config/courierCodes";
import moment from "moment";
let rules = {
  JNT: {
    maxSize: {
      width: 100,
      length: 100,
      height: 100,
    },
    maxWLH: 180,
    dimensionRatio: 6000,
  },
  BEST: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 600,
    dimensionRatio: 6000,
  },
  TRUE: {
    maxSize: {
      width: 150,
      length: 150,
      height: 150,
    },
    maxWLH: 200,
  },
  ECP: {
    maxSize: {
      width: 60,
      length: 60,
      height: 70,
    },
  },
  FLE: {
    maxSize: {
      width: 150,
      length: 150,
      height: 150,
    },
    maxWLH: 280,
    alertText: {
      text: [
        "เนื่องจาก Flash Express มีการปรับปรุงระบบเข้ารับพัสดุ",
        "กรุณาแยกกองพัสดุเพื่อให้ขนส่งเข้ารับโดยรายการที่สร้างภายในวันที่ 18 พ.ย. 64 ก่อนเวลา 23.59น. ไว้กองหนึ่งและรายการที่สร้างหลังจากวันและเวลาดังกล่าวไว้อีกกองหนึ่ง",
      ],
    },
  },
  FLEWP: {
    maxSize: {
      width: 150,
      length: 150,
      height: 150,
    },
    maxWLH: 40,
    maxWeight: 1000,
  },
  BEE: {
    maxSize: {
      width: 100,
      height: 100,
      length: 100,
    },
    maxWLH: 150,
    dimensionRatio: 6000,
    alertText: {
      text: "ขนส่งจะเข้ารับเฉพาะต้นทางในจังหวัดกรุงเทพมหานครเท่านั้น กรณีจะทำการส่งพัสดุ ขนาดกล่อง (กว้าง+ยาว+สูง) รวมกันทุกด้านเกิน 130 เซนติเมตร หรือด้านใดด้านหนึ่งเกินกว่า 50 เซนติเมตร หรือน้ำหนักเกินกว่า 7 กิโลกรัม จะต้องทำ",
      emphasize: "รายการล่วงหน้าอย่างน้อย 1 วัน",
    },
  },
  TPSD: {
    maxSize: {
      width: 100,
      height: 100,
      length: 100,
    },
    maxWLH: 150,
    dimensionRatio: 6000,
  },
  EMST: {
    maxSize: {
      width: 120,
      length: 120,
      height: 120,
    },
    maxWLH: 190,
  },
  TP2: {
    maxSize: {
      width: 120,
      length: 120,
      height: 120,
    },
    maxWLH: 120,
  },
  THP: {
    maxSize: {
      width: 120,
      length: 120,
      height: 120,
    },
    maxWLH: 190,
  },
  MSE: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 200,
    alertText: {
      text: "ขนส่งนี้ ต้องมียอดการจัดส่งพัสดุขั้นต่ำ 3 ชิ้นขึ้นไป",
      emphasize: "",
    },
  },
  MSEC: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 200,
    alertText: {
      text: "ขนส่งนี้ ต้องมียอดการจัดส่งพัสดุขั้นต่ำ 3 ชิ้นขึ้นไป",
      emphasize: "",
    },
  },
  SPE: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 200,
    alertText: {
      text: "ขนส่งนี้ ต้องมียอดการจัดส่งพัสดุขั้นต่ำ 3 ชิ้นขึ้นไป",
      emphasize: "",
    },
  },
  SPEC: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 200,
    alertText: {
      text: "ขนส่งนี้ ต้องมียอดการจัดส่งพัสดุขั้นต่ำ 3 ชิ้นขึ้นไป",
      emphasize: "",
    },
  },
  CJLX: {
    maxSize: {
      width: 100,
      length: 100,
      height: 100,
    },
    maxWLH: 180,
  },
  EMSXP: {
    maxSize: {
      width: 60,
      length: 60,
      height: 60,
    },
    maxWLH: 120,
  },
  KRYQ: {
    maxSize: {
      width: 200,
      length: 200,
      height: 200,
    },
    maxWLH: 280,
  },
  NJV: {
    maxSize: {
      width: 180,
      length: 180,
      height: 180,
    },
    maxWLH: 180,
    maxWeight: 20000,
  },
};
rules[_COURIERS_.DHL.key] = {
  maxSize: {
    width: 170,
    length: 170,
    height: 170,
  },
  maxWLH: 200,
  // dimensionRatio: 5000,
  alertText: {
    text: [
      "การสร้างรายการ: จันทร์ ถึง วันอาทิตย์",
      "การเข้ารับ: วันจันทร์ - เสาร์",
      "สร้างรายการก่อน 11.00น. เข้ารับภายในวัน",
      "กรณีพัสดุขนาดเกินทุกด้านรวมกันเกิน 200 ซม. หรือน้ำหนักเกิน 30 กิโลกรัม ทางขนส่งจะปฎิเสธการจัดส่งพัสดุ",
    ],
    emphasize: "Pick up เท่านั้น ไม่สามารถนำไป Drop เองที่สาขาได้",
  },
  // workingDays: [2, 3, 4, 5, 6],
  // workingHours: {
  //   1: "all",
  //   2: "all",
  //   // 2: {
  //   //   start: {hour: 11},
  //   // },
  //   3: "all",
  //   4: "all",
  //   5: "all",
  //   6: "all",
  //   // 6: {
  //   //   end: {hour: 11},
  //   // },
  // },
};
const courierRules = {
  shippopCourierKeys: [
    "TP2",
    "THP",
    "FLE",
    "FLEWP",
    "CJLX",
    "NJV",
    "TRUE",
    "SCG",
    "SCGC",
    "SCGF",
    "JNT",
    "ECP",
    "BEST",
    "EMST",
    "BEE",
    "TPSD",
    "MSE",
    "MSEC",
    "SPE",
    "SPEC",
    "KRYS",
    "EMSXP",
    "KRYQ",
    _COURIERS_.DHL.key,
  ],
  // courier check remote area
  extraCouriers: [
    "FLE",
    "FLEWP",
    "SCG",
    "CJLX",
    "NJV",
    "SCGC",
    "SCGF",
    "JNT",
    "BEST",
    "MSE",
    "MSEC",
    "SPE",
    "SPEC",
  ],
  dimensionCouriers: [
    "SCG",
    "TRUE",
    "FLE",
    "FLEWP",
    "SCGC",
    "SCGF",
    "NJV",
    "BEE",
    "TPSD",
    "MSE",
    "MSEC",
    "SPE",
    "SPEC",
    "KRYS",
    "CJLX",
    "KRYQ",
    "SPGENDIM",
    _COURIERS_.DHL.key,
  ],
  lockWeightCouriers: ["KRYS"],
  lockDimensionCouriers: ["SCG", "SCGC", "SCGF", "KRYS"],
  workingDayOfCourier: [_COURIERS_.DHL.key],
  // 1="Monday"
  // 2="Tuesday"
  // 3="Wednesday"
  // 4="Thursday"
  // 5="Friday"
  // 6="Saturday"
  // 0="Sunday"
  alertBeforeCreateOrderCouriers: [
    "BEE",
    "TPSD",
    "MSE",
    "MSEC",
    "SPE",
    "SPEC",
    _COURIERS_.DHL.key,
  ],
  ...rules,
};
export default courierRules;
